import { createContext } from 'react';
import type { HappeningsContextType } from '../types/context';
const HappeningsContext = createContext<HappeningsContextType | undefined>(undefined);

export { HappeningsContext };
